import * as React from "react";

function CircleMinusIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M17.0175 33.6668C7.8125 33.6668 0.35083 26.2052 0.35083 17.0002C0.35083 7.79516 7.8125 0.333496 17.0175 0.333496C26.2225 0.333496 33.6842 7.79516 33.6842 17.0002C33.6842 26.2052 26.2225 33.6668 17.0175 33.6668ZM17.0175 30.3335C20.5537 30.3335 23.9451 28.9287 26.4456 26.4283C28.9461 23.9278 30.3508 20.5364 30.3508 17.0002C30.3508 13.4639 28.9461 10.0726 26.4456 7.57207C23.9451 5.07159 20.5537 3.66683 17.0175 3.66683C13.4813 3.66683 10.0899 5.07159 7.58941 7.57207C5.08892 10.0726 3.68416 13.4639 3.68416 17.0002C3.68416 20.5364 5.08892 23.9278 7.58941 26.4283C10.0899 28.9287 13.4813 30.3335 17.0175 30.3335ZM8.68416 15.3335H25.3508V18.6668H8.68416V15.3335Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoCircleMinusIcon = React.memo(CircleMinusIcon);
export default MemoCircleMinusIcon;
